import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";

export const UPSERT_UI_SETTINGS_SUCCESS =
  "ORGANIZATION:UPSERT_UI_SETTINGS_SUCCESS";

export interface UpsertUISettingsSuccessAction extends Action {
  type: typeof UPSERT_UI_SETTINGS_SUCCESS;
  organization: OrganizationKeyName;
}

export const upsertUISettingsSuccess = (
  organization: OrganizationKeyName
): UpsertUISettingsSuccessAction => ({
  type: UPSERT_UI_SETTINGS_SUCCESS,
  organization,
});
